// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";

function getFareEstimateResultUrl(query_params) {
  return encodeURI(UrlUtils$Catalyst.createRequestURLfrmParams(Config$PorterinUtils.oms_url, "/fare_estimate_v4", Js_dict.fromList({
                      hd: [
                        "from_address_landmark",
                        window.encodeURIComponent(Belt_Option.getWithDefault(query_params.from_address_landmark, ""))
                      ],
                      tl: {
                        hd: [
                          "from_address_lat",
                          Belt_Option.getWithDefault(query_params.from_address_lat, "")
                        ],
                        tl: {
                          hd: [
                            "from_address_long",
                            Belt_Option.getWithDefault(query_params.from_address_long, "")
                          ],
                          tl: {
                            hd: [
                              "to_address_landmark",
                              window.encodeURIComponent(Belt_Option.getWithDefault(query_params.to_address_landmark, ""))
                            ],
                            tl: {
                              hd: [
                                "to_address_lat",
                                Belt_Option.getWithDefault(query_params.to_address_lat, "")
                              ],
                              tl: {
                                hd: [
                                  "to_address_long",
                                  Belt_Option.getWithDefault(query_params.to_address_long, "")
                                ],
                                tl: {
                                  hd: [
                                    "geo_region_id",
                                    Belt_Option.getWithDefault(query_params.geo_region_id, "")
                                  ],
                                  tl: {
                                    hd: [
                                      "customer_name",
                                      Belt_Option.getWithDefault(query_params.customer_name, "")
                                    ],
                                    tl: {
                                      hd: [
                                        "customer_mobile",
                                        Belt_Option.getWithDefault(query_params.customer_mobile, "")
                                      ],
                                      tl: {
                                        hd: [
                                          "frequency",
                                          Belt_Option.getWithDefault(query_params.frequency, "")
                                        ],
                                        tl: {
                                          hd: [
                                            "brand",
                                            Belt_Option.getWithDefault(query_params.brand, "")
                                          ],
                                          tl: {
                                            hd: [
                                              "is_device_mobile",
                                              Belt_Option.getWithDefault(query_params.is_device_mobile, "")
                                            ],
                                            tl: {
                                              hd: [
                                                "fare_estimate_token",
                                                Belt_Option.getWithDefault(query_params.fare_estimate_token, "")
                                              ],
                                              tl: {
                                                hd: [
                                                  "service_category",
                                                  Belt_Option.getWithDefault(query_params.service_category, "")
                                                ],
                                                tl: {
                                                  hd: [
                                                    "utm_source",
                                                    Belt_Option.getWithDefault(query_params.utm_source, "")
                                                  ],
                                                  tl: {
                                                    hd: [
                                                      "utm_medium",
                                                      Belt_Option.getWithDefault(query_params.utm_medium, "")
                                                    ],
                                                    tl: {
                                                      hd: [
                                                        "utm_campaign",
                                                        Belt_Option.getWithDefault(query_params.utm_campaign, "")
                                                      ],
                                                      tl: {
                                                        hd: [
                                                          "utm_content",
                                                          Belt_Option.getWithDefault(query_params.utm_content, "")
                                                        ],
                                                        tl: {
                                                          hd: [
                                                            "utm_term",
                                                            Belt_Option.getWithDefault(query_params.utm_term, "")
                                                          ],
                                                          tl: {
                                                            hd: [
                                                              "source_url",
                                                              window.encodeURIComponent(document.referrer)
                                                            ],
                                                            tl: {
                                                              hd: [
                                                                "result",
                                                                Belt_Option.getWithDefault(query_params.result, "")
                                                              ],
                                                              tl: {
                                                                hd: [
                                                                  "prev_callback_req_id_present",
                                                                  Belt_Option.getWithDefault(query_params.prev_callback_req_id_present, "")
                                                                ],
                                                                tl: {
                                                                  hd: [
                                                                    "callback_request_id",
                                                                    Belt_Option.getWithDefault(query_params.callback_request_id, "")
                                                                  ],
                                                                  tl: {
                                                                    hd: [
                                                                      "is_existing_cust",
                                                                      Belt_Option.getWithDefault(query_params.is_existing_cust, "")
                                                                    ],
                                                                    tl: {
                                                                      hd: [
                                                                        "lead_entry_created",
                                                                        Belt_Option.getWithDefault(query_params.lead_entry_created, "")
                                                                      ],
                                                                      tl: /* [] */0
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    })));
}

export {
  getFareEstimateResultUrl ,
}
/* Config-PorterinUtils Not a pure module */
